import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface FeeSummaryCustomer {
  businessId: string;
  name: string;
  type: string | null;
  regNumber: string | null;
  email: string | null;
  phone: string | null;
  contact: string | null;
}

export interface FeeSummaryPolicy {
  scope: string | null;
  name: string | null;
  calculationMethod: string | null;
  feeRate: string | null;
  feeBasis: string | null;
  minFeeAmount: string | null;
  maxFeeAmount: string | null;
  effectiveFrom: string | null;
}

export interface FeeSummaryTotals {
  orderCount: number;
  revenue: string;
  feeRate: string | null;
  feeDue: string;
  feeCurrency: string;
  feeStatus: "PAYABLE" | "SETTLED" | "PARTIAL";
}

export interface FeeSummaryTxn {
  orderId: string;
  orderNumber: string;
  baseAmount: string;
  appliedRate: string | null;
  finalFeeAmount: string;
  feeCurrency: string;
  status: string;
  collectedAt: string | null;
}

export interface FeeSummaryResponse {
  customer: FeeSummaryCustomer;
  policy: FeeSummaryPolicy | null;
  summary: FeeSummaryTotals;
  txns: FeeSummaryTxn[];
}

export const feeSummary = (customerId: string) =>
  httpRequest.get(`/bil/my/customers/${customerId}/fee-summary`) as Promise<FeeSummaryResponse>;

export const sendFeeInvoice = (customerId: string, period?: string | null) =>
  httpRequest.post(`/bil/my/customers/${customerId}/fee-invoice/send`, { period: period ?? null }) as Promise<{
    sent: boolean;
    email: string;
    amount: string;
    currency: string;
  }>;
